import type { ChangeEvent, FocusEvent } from 'react'

import Input from '@space-lib/components/form/textField'

import clsx from 'clsx'
import styled from 'styled-components'

const InputCounter = styled.div`
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  color: var(--gray-500);
  background-color: var(--dropdown-background-color);

  span {
    color: inherit;
    font-size: inherit;
  }
`

const TextField = styled(Input)`
  &::placeholder {
    color: var(--gray-700) !important;
  }
`

export type CustomInputProps = {
  name: string
  placeholder: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  value: string
  label?: string
  className?: string
  maxSize?: number
  currentSize?: number
  disabled?: boolean
  hasError?: boolean
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void
}

const CustomInput = ({
  name,
  placeholder,
  onChange,
  value,
  label,
  className,
  maxSize = 0,
  currentSize = 0,
  disabled = false,
  hasError = false,
  onBlur
}: CustomInputProps) => {
  return (
    <div className={clsx('hot-form', className)}>
      {label && (
        <label htmlFor={name} className='hot-form__label'>
          {label}
        </label>
      )}
      <div className='_position-relative'>
        {maxSize > 0 ? (
          <InputCounter
            className='_position-absolute _d-flex _flex-row _align-items-center _justify-content-start _mr-3 _text-1'
            data-test='input-value-counter'>
            <span>{currentSize}</span>
            <span>/</span>
            <span>{maxSize}</span>
          </InputCounter>
        ) : null}
        <TextField
          aria-label={placeholder}
          className='hot-form__input _bg-transparent _text-gray-700 _pr-8'
          type='text'
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          disabled={disabled}
          autoComplete='off'
          hasError={hasError}
          onBlur={onBlur}
        />
      </div>
    </div>
  )
}

export default CustomInput
